function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#FAFAFA;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#FAFAFA;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FAFAFA;stroke:#FAFAFA;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "foto",
  transform: "translate(-287.49 -195.547)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_119",
  className: "st0",
  d: "M301.3,205.8c1,1,1,2.6,0,3.5s-2.6,1-3.5,0c-1-1-1-2.6,0-3.5 C298.7,204.8,300.3,204.8,301.3,205.8C301.3,205.8,301.3,205.8,301.3,205.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_120",
  className: "st1",
  d: "M305.5,204H303l-2-2h-3l-2,2h-2.5c-0.8,0-1.5,0.7-1.5,1.5v5c0,0.8,0.7,1.5,1.5,1.5h12 c0.8,0,1.5-0.7,1.5-1.5v-5C307,204.7,306.3,204,305.5,204z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_121",
  className: "st2",
  d: "M305,205.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S305.3,205.5,305,205.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_122",
  className: "st0",
  d: "M307.6,199.4c4.5,4.5,4.5,11.8,0,16.3s-11.8,4.5-16.3,0c-4.5-4.5-4.5-11.8,0-16.3 C295.8,194.9,303.1,194.9,307.6,199.4C307.6,199.4,307.6,199.4,307.6,199.4"
}));

function SvgFoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoto);
export default __webpack_public_path__ + "static/media/foto.bd95126f.svg";
export { ForwardRef as ReactComponent };